import { ClaudeTemplate } from "../types";

/** Plataforma sin determinar o sin plantilla propia: estructura típica de cualquier herramienta. */
export const genericTemplate: ClaudeTemplate = {
  id: "generic",
  tool: "la plataforma publicitaria de esta línea",
  url: "no se sabe: el briefing no indica la herramienta",
  hierarchy:
    "La típica de cualquier herramienta: Cuenta → Campaña → Grupo de anuncios / ad set / line item → Anuncios",
  idHint: "ID de la campaña donde lo muestre la herramienta (URL o detalle)",
  steps: `
El briefing **no indica en qué herramienta se monta esta línea** (o no tenemos plantilla para ella).

### 1. Averiguar la herramienta
1. Pregúntame en qué plataforma hay que montarla, salvo que ya la tenga abierta en el navegador; en ese caso, dime cuál ves y espera mi confirmación.

### 2. Montar la estructura (cuando sepamos la herramienta)
1. Entra en la cuenta de {{client}}. Si hay varias, pregunta.
2. Campaña: nombre {{names.order}}, objetivo que encaje con {{goal.kpi}}, fechas {{goal.startDate}} → {{goal.endDate}}, presupuesto {{goal.budget}}. Si ya existe, no la dupliques.
3. Grupo / ad set / line item: nombre {{names.line}}, puja en torno a {{goal.netUnitCost}}, segmentación del bloque "Segmentación".
4. Anuncios: piezas del bloque "Creatividades", textos del bloque "Copies", URL de destino con UTM.
5. Deja todo **en pausa o en borrador**.
`,
};
